import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import FunctionGeneral from '../functionsGeneral';
import ContractsService from '../../../../services/ContractsService';
import Globals from '../../../../Globals';
import Loading from '../../../bronson/Loading';
import Input from '../../../bronson/Input';

const ModalCancelacionesCliente = props => {
    const [loaded, setloaded] = useState(false);
    const [typeValue, setTypeValue] = useState('');
    const [contractList, setContractList] = useState([]);
    const [selectedContract, setSelectedContract] = useState('');

    useEffect(() => {
        window.bronson.ComponentRegister.initAll();
    }, []);

    async function CargarContratosCliente(props) {
        setloaded(true);
        var _dataContratosCliente = await new ContractsService().cargarContratosCliente(
            props.cookies.get(Globals.COOKIES.JWT).AccessToken,
            props.dealerCodeVWF,
            document.getElementById('nif').value
        );
        if (
            _dataContratosCliente &&
            _dataContratosCliente.statusCode === 200 &&
            _dataContratosCliente.body &&
            _dataContratosCliente.body.Result
        ) {
            setContractList(JSON.parse(_dataContratosCliente.body.Result));
            setloaded(false);
        }
        setloaded(false);
    }

    return (
        <React.Fragment>
            <Loading ariaBusy={loaded}></Loading>
            <div className="c-modal" aria-hidden={'false'}>
                <div className="c-modal__overlay js-modal-close"></div>
                <div
                    className="c-modal__wrapper modalFichaCliente"
                    role="dialog"
                    aria-labelledby="foo-bar-baz"
                >
                    <header className="c-modal__header">
                        <div className="o-layout__item u-11/12">
                            <div className="u-1/1">
                                <div className="c-icon colorBlue iconContrato" />
                                <label className="u-h3 u-ml-xsmall">
                                    Cancelaciones cliente
                                </label>
                            </div>
                        </div>
                        <div className="o-layout__item u-1/12">
                            <button
                                // onClick={() => changeAccion('SALIR')}
                                onClick={() => {
                                    props.setModalCancelacionesCliente(false);
                                }}
                                className="c-modal__close-btn  js-modal-close"
                                type="button"
                                aria-label="Close this dialog window."
                            />
                        </div>
                    </header>
                    {contractList.length == 0 ? (
                        <div className="c-modal__content NIFModal">
                            <div className="gridContainerModal o-layout">
                                <div
                                    className="o-layout__item u-1/1 fc-margintop-10"
                                    style={{ marginTop: '40px' }}
                                >
                                    <label className="u-text-base u-1/1 u-text-left">
                                        NIF o CIF
                                    </label>
                                    <Input
                                        options={{
                                            id: 'nif',
                                            type: 'text',
                                            placeHolder: 'Introduce un NIF',
                                            autoComplete: 'off',
                                        }}
                                        onChange={() => {}}
                                    />
                                    <div style={{ marginTop: '40px' }}>
                                        <p className="u-text-left">
                                            El CIF/NIF debe de pertenecer a un
                                            cliente de tu concecionario. En caso
                                            contrario no se permitira continuar.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-center"></div>
                            <div className="o-layout__item u-1/2 u-text-center">
                                <button
                                    className="u-text-brand c-btn scoring-table-button u-float-left"
                                    style={{ width: '60%' }}
                                    onClick={() =>
                                        CargarContratosCliente(props)
                                    }
                                >
                                    CONTINUAR
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="c-modal__content ContratosModal">
                            <div className="gridContainerModal o-layout">
                                <div
                                    className="o-layout__item u-1/1 fc-margintop-10"
                                    style={{ marginTop: '40px' }}
                                >
                                    <label className="u-text-base u-1/1 u-text-left">
                                        Seleccione el contrato del cliente sobre
                                        el que quiere realizar la cancelación
                                    </label>
                                    <div className="o-layout__item u-1/1 fc-margintop-10">
                                        <div className="c-form-field__box u-4/5">
                                            <div className="c-input c-input--select">
                                                <select
                                                    className="c-input__input"
                                                    onChange={e =>
                                                        setSelectedContract(
                                                            e.target.value
                                                        )
                                                    }
                                                    value={selectedContract}
                                                >
                                                    <option value="" key={''}>
                                                        Seleccione un contrato
                                                    </option>
                                                    {contractList &&
                                                        contractList.map(
                                                            contract => (
                                                                <option
                                                                    key={
                                                                        contract.operation_code
                                                                    }
                                                                    value={
                                                                        contract.operation_code
                                                                    }
                                                                >
                                                                    {contract.operation_code +
                                                                        ' - ' +
                                                                        contract.license_plate +
                                                                        ' - ' +
                                                                        contract.vin_code}
                                                                </option>
                                                            )
                                                        )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div style={{ marginTop: '40px' }}>
                                        <p className="u-text-left">
                                            EL CIF/NIF debe de pertenecer a un
                                            cliente de tu concecionario. En caso
                                            contrario no se permitira continuar.
                                        </p>
                                    </div> */}
                                </div>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-center">
                                <button
                                    className="CancelActividad c-btn--secondary c-btn u-float-right"
                                    style={{ marginRight: '20px' }}
                                    onClick={() => setContractList([])}
                                >
                                    VOLVER
                                </button>
                            </div>
                            <div className="o-layout__item u-1/2 u-text-center">
                                <button
                                    className="u-text-brand c-btn scoring-table-button u-float-left"
                                    style={{ width: '60%' }}
                                    onClick={() => {
                                        props.setFinancialOperationCode(
                                            selectedContract
                                        );
                                        props.setModalCancelacionesCliente(
                                            false
                                        );
                                    }}
                                >
                                    CONTINUAR
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};
export default withRouter(ModalCancelacionesCliente);
